var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"top-spaced-item multi-line custom-alert pb-0 pl-14 mb-8",attrs:{"text":"","color":"#BF0000","type":"error","icon":false}},[_c('p',[_vm._v(" Special characters may cause issues. Use letters (a–z) and numbers (0–9) for best results. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }